"use client";

import { useEffect, useState } from "react";

// darkPreset is opt-in: only callers that pass it get a theme-swapped
// material (currently just the homepage hero, which wants a dark, still
// iridescent look instead of white glass once dark mode is on).
// Every other AmpersandHero usage picks a preset intentionally and stays
// fixed regardless of theme.
export default function AmpersandHero({ preset = "glass", darkPreset, motion = "alive", presence = "1.6", clip = "off", src, morph, fit, spin, lens, refractText }) {
  const [theme, setTheme] = useState("light");

  useEffect(() => {
    import("../lib/webgl/ampersand3d.js");
  }, []);

  useEffect(() => {
    if (!darkPreset) return;
    const root = document.documentElement;
    setTheme(root.getAttribute("data-theme") || "light");
    const observer = new MutationObserver(() => setTheme(root.getAttribute("data-theme") || "light"));
    observer.observe(root, { attributes: true, attributeFilter: ["data-theme"] });
    return () => observer.disconnect();
  }, [darkPreset]);

  const activePreset = darkPreset && theme === "dark" ? darkPreset : preset;

  // Renders inert until ampersand3d.js registers <amp-3d>, then the
  // browser upgrades it in place — no need to gate on load state.
  return <amp-3d aria-hidden="true" preset={activePreset} motion={motion} presence={presence} clip={clip} src={src} morph={morph} fit={fit} spin={spin} lens={lens} refract-text={refractText}></amp-3d>;
}
